import { OfferAcceptanceStatus, OfferAcceptanceType, } from '@/api/v2/requests/offers';
import { mdiDomain, mdiSitemap, mdiMapMarker } from '@mdi/js';
export const useAcceptanceColumns = (ctx, { offer, decisionSelectId, isReadOnlyAcceptance }) => {
    const acceptanceColumns = [
        {
            field: 'statuses',
            colId: decisionSelectId,
            headerName: ctx.root.$t('offer-costs.decisionLabel').toString(),
            width: 150,
            cellRenderer: 'ObjectDecisionCell',
            cellRendererParams: (params) => {
                return {
                    centralStatus: params?.value,
                };
            },
            pinned: 'right',
            suppressMovable: true,
            valueGetter: (params) => {
                const centralStatus = (params?.data?.statuses ?? []).find((status) => status.type === OfferAcceptanceType.CENTRAL);
                return centralStatus?.status;
            },
            ...(isReadOnlyAcceptance
                ? {}
                : {
                    filter: true,
                    floatingFilter: true,
                    suppressHeaderMenuButton: true,
                    floatingFilterComponent: 'FloatingSelectFilter',
                    floatingFilterComponentParams: () => {
                        return {
                            id: decisionSelectId,
                            hideAutocomplete: true,
                            options: [
                                OfferAcceptanceStatus.ACCEPTED,
                                OfferAcceptanceStatus.REJECTED,
                                OfferAcceptanceStatus.REVERTED,
                            ].map((value) => ({ value, label: value })),
                            getLabel: (value) => {
                                return ctx.root.$t(`offer-costs.decision.${value}`);
                            },
                        };
                    },
                    suppressFloatingFilterButton: true,
                }),
        },
        {
            field: 'statuses',
            colId: 'centralStatus',
            sortable: false,
            headerName: '',
            headerComponent: 'IconHeader',
            headerClass: 'ag-header-cell--icon',
            headerComponentParams: {
                icon: mdiDomain,
                tooltipKey: 'offer-costs.approvalCentral',
            },
            width: 60,
            cellStyle: {
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            cellRenderer: 'ObjectAcceptCell',
            cellRendererParams: (params) => {
                return {
                    level: OfferAcceptanceType.CENTRAL,
                    offerId: offer.id,
                    offerStatus: offer.status,
                    expiresAt: offer.expiresAt ?? null,
                    statuses: params?.data.statuses,
                    objectId: params?.data.id,
                    isReadOnlyAcceptance,
                };
            },
            pinned: 'right',
            suppressMovable: true,
        },
        {
            field: 'statuses',
            colId: 'structureStatus',
            sortable: false,
            headerName: '',
            headerComponent: 'IconHeader',
            headerClass: 'ag-header-cell--icon',
            headerComponentParams: {
                icon: mdiSitemap,
                tooltipKey: 'offer-costs.approvalStructure',
            },
            width: 60,
            cellStyle: {
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            cellRenderer: 'ObjectAcceptCell',
            cellRendererParams: (params) => {
                return {
                    level: OfferAcceptanceType.STRUCTURE,
                    offerId: offer.id,
                    offerStatus: offer.status,
                    expiresAt: offer.expiresAt ?? null,
                    statuses: params?.data.statuses,
                    objectId: params?.data.id,
                    isReadOnlyAcceptance,
                };
            },
            pinned: 'right',
            suppressMovable: true,
        },
        {
            field: 'statuses',
            colId: 'placeStatus',
            sortable: false,
            headerName: '',
            headerComponent: 'IconHeader',
            headerClass: 'ag-header-cell--icon',
            headerComponentParams: {
                icon: mdiMapMarker,
                tooltipKey: 'offer-costs.approvalPlace',
            },
            width: 60,
            cellStyle: {
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            cellRenderer: 'ObjectAcceptCell',
            cellRendererParams: (params) => {
                return {
                    level: OfferAcceptanceType.PLACE,
                    offerId: offer.id,
                    offerStatus: offer.status,
                    expiresAt: offer.expiresAt ?? null,
                    statuses: params?.data.statuses,
                    objectId: params?.data.id,
                    isReadOnlyAcceptance,
                };
            },
            pinned: 'right',
            suppressMovable: true,
        },
    ];
    return { acceptanceColumns };
};
